module.exports = __webpack_public_path__ + "static/media/header-notification.18eef2be.svg";